import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { FiFileText } from "react-icons/fi";
import { toast } from "react-toastify";

import { acknowledgeRecurringDebits } from "actions/employerActions";
import { employerConstants } from "actions/types";
import Alert from "components/Alert";
import { createErrorSelector } from "store/selectors";
import { hasAcknowledgedRecurringDebits } from "store/selectors/employer";
import type { RootState } from "types/state";

import Accordian from "./Accordian";
import PayrollIntegratedACHDisclaimer from "./PayrollIntegratedACHDisclaimer";

const statusErrorSelector = createErrorSelector([
  employerConstants.GET_RECURRING_DEBITS_ACKNOWLEDGMENT,
]);

const mapStateToProps = (state: RootState) => {
  return {
    hasAcknowledgedRecurringDebits: hasAcknowledgedRecurringDebits(state),
    statusError: statusErrorSelector(state),
  };
};

const mapDispatchToProps = {
  acknowledgeRecurringDebits,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  hasBank: boolean;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

const AcknowledgeRecurringDebitsCard = (props: Props) => {
  const handleAcknowledge = async () => {
    const result = await props.acknowledgeRecurringDebits(
      props.client as ApolloClient<object>
    );
    if (result.success) {
      toast.success("Recurring debits acknowledged.");
    }
  };

  const steps = [
    {
      index: 1,
      label: "Review and acknowledge recurring debits",
      content: (
        <>
          {props.statusError && (
            <Alert
              type="error"
              msg="We couldn't check whether you've already acknowledged recurring debits. You can still submit below."
            />
          )}
          <PayrollIntegratedACHDisclaimer
            onClick={() => void handleAcknowledge()}
          />
        </>
      ),
    },
  ];

  return (
    <Accordian
      icon={<FiFileText color="white" stroke="#60A4BF" size={16} />}
      title={"Acknowledgment of recurring debits"}
      description={
        "Authorize Icon to debit your bank account according to your payroll."
      }
      disabled={!props.hasBank}
      completedAction={props.hasAcknowledgedRecurringDebits}
      steps={steps}
      activeStepNumber={1}
    />
  );
};

export default connector(withApollo<Props>(AcknowledgeRecurringDebitsCard));
